import { useClientSnapshot } from 'src/custom-hooks/use-client-snapshot';
import {
  matchDesktop,
  matchHeaderDesktop,
  matchLargeDesktop,
  matchLargeTablet,
  matchSmallTablet,
  useMatchMedia,
} from 'src/styling/media-queries';

export type UseWindowSizeBreakpoints = {
  isMobileOrSmaller: boolean;
  isSmallTabletOrSmaller: boolean;
  isTabletOrSmaller: boolean;
  isLargeDesktopOrSmaller: boolean;
  isMobileHeader: boolean;
  isWindowSizeReady: boolean;
};

const useWindowSize = (): UseWindowSizeBreakpoints => ({
  isMobileOrSmaller: !useMatchMedia(matchSmallTablet, true),
  isSmallTabletOrSmaller: !useMatchMedia(matchLargeTablet, true),
  isTabletOrSmaller: !useMatchMedia(matchDesktop, true),
  isLargeDesktopOrSmaller: !useMatchMedia(matchLargeDesktop, true),
  isMobileHeader: !useMatchMedia(matchHeaderDesktop, true),
  isWindowSizeReady: useClientSnapshot(() => true, false),
});

export default useWindowSize;
